import http from 'hub-http/clients/apiClient';
import { BASE_API_URL } from '../constants';
export function publishInstance(instanceId) {
  // This needs to use http.postWithResponse in order to work with makeStructuredContentPublishAction
  return http.postWithResponse(`${BASE_API_URL}/${instanceId}/draft/push-live`);
}
export const unpublishInstance = instanceId => {
  // This needs to use http.postWithResponse in order to work with makeStructuredContentPublishAction
  return http.postWithResponse(`${BASE_API_URL}/${instanceId}/unpublish`);
};
export const createInstance = (groupId, title) => {
  return http.post(`${BASE_API_URL}`, {
    data: {
      values: {
        hs_group_id: groupId,
        hs_name: title
      }
    }
  });
};
export const deleteInstance = instanceId => {
  return http.delete(`${BASE_API_URL}/${instanceId}`);
};
export const cloneInstance = (instanceId, groupId, cloneName) => {
  return http.post(`${BASE_API_URL}/${instanceId}/clone`, {
    data: {
      hs_name: cloneName,
      values: {
        hs_group_id: groupId
      }
    }
  });
};
export function fetchInstance(id) {
  return http.get(`${BASE_API_URL}/${id}/draft`);
}